import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <span className="status-indicator">🟢</span>
          <span className="status-text">Ready</span>
        </div>
        <div className="footer-center">
          <span className="footer-tagline">Smart Downloading with AI – Universal Downloader Pro</span>
        </div>
        <div className="footer-right">
          <span className="version">v2.0</span>
          <span className="copyright">© 2025 Universal Video Downloader</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
